import React from 'react';
import { useTheme } from '../ThemeContext';

const NotFound = ({ onHome }) => {
  const { colors } = useTheme();
  return (
    <div className="app-scroll app-scroll-center" style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1.5rem',
      background: colors.background,
    }}>
      <div style={{
        width: '100%',
        maxWidth: '420px',
        textAlign: 'center',
        background: colors.surface,
        border: `1px solid ${colors.border}`,
        borderRadius: '1rem',
        padding: '2rem 1.25rem',
      }}>
        <h1 style={{ color: colors.text, fontSize: '1.6rem', margin: '0 0 0.5rem' }}>Page not found</h1>
        <p style={{ color: colors.textSecondary, margin: '0 0 1.5rem' }}>
          That address isn’t a Pacarion page.
        </p>
        <button
          type="button"
          onClick={onHome}
          style={{
            background: '#59c4c4',
            color: 'white',
            border: 'none',
            borderRadius: '0.75rem',
            padding: '0.85rem 1.25rem',
            fontWeight: '700',
            fontSize: '1rem',
            cursor: 'pointer',
            width: '100%',
          }}
        >
          Home
        </button>
      </div>
    </div>
  );
};

export default NotFound;
